import { UIComponent } from "@aptus/frontend-core";
import { AutoCompleteSelect } from "components/form/autoCompleteSelect/autoCompleteSelect";
import { CountrySelectProps, useCountrySelect } from "./useCountrySelect";

export const CountrySelect: UIComponent<CountrySelectProps> = (props) => (
	<AutoCompleteSelect {...useCountrySelect(props)} />
);
